"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHublVariableLabel = exports.getEmailSystemHublVar = exports.EmailSystemHublVariables = exports.getHublVariable = exports.hasHublVariable = exports.HUBL_VAR_REGEXP = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var HUBL_VAR_REGEXP = /^{{\s*([a-zA-Z0-9_.]+)\s*}}$/;
exports.HUBL_VAR_REGEXP = HUBL_VAR_REGEXP;

var hasHublVariable = function hasHublVariable(str) {
  return /{{.*}}/.test(str);
};

exports.hasHublVariable = hasHublVariable;

var getHublVariable = function getHublVariable(str) {
  if (typeof str !== 'string') {
    return null;
  }

  var matches = str.trim().match(HUBL_VAR_REGEXP);
  return matches ? matches[1] : null;
};

exports.getHublVariable = getHublVariable;
var EmailSystemHublVariables = {
  UNSUBSCRIBE: 'unsubscribe_link',
  UNSUBSCRIBE_ALL: 'unsubscribe_link_all',
  VIEW_AS_WEBPAGE: 'view_as_page_url',
  SUBSCRIPTION_CONFIRMATION: 'subscription_confirmation_url'
};
exports.EmailSystemHublVariables = EmailSystemHublVariables;

var getEmailSystemHublVar = function getEmailSystemHublVar(str) {
  var hublVar = getHublVariable(str);

  for (var key in EmailSystemHublVariables) {
    if (hublVar === EmailSystemHublVariables[key]) {
      return hublVar;
    }
  }

  return null;
};

exports.getEmailSystemHublVar = getEmailSystemHublVar;

var getHublVariableLabel = function getHublVariableLabel(name) {
  switch (name) {
    case EmailSystemHublVariables.UNSUBSCRIBE:
      return _I18n.default.text('RichTextLib.links.emailSystemLinks.unsubscribe');

    case EmailSystemHublVariables.UNSUBSCRIBE_ALL:
      return _I18n.default.text('RichTextLib.links.emailSystemLinks.unsubscribeAll');

    case EmailSystemHublVariables.VIEW_AS_WEBPAGE:
      return _I18n.default.text('RichTextLib.links.emailSystemLinks.viewAsWebpage');

    case EmailSystemHublVariables.SUBSCRIPTION_CONFIRMATION:
      return _I18n.default.text('RichTextLib.links.emailSystemLinks.subscriptionConfirmation');

    default:
      return name;
  }
};

exports.getHublVariableLabel = getHublVariableLabel;